module.exports = __webpack_public_path__ + "img/Partners5.487d5b84.png";